module.exports = __webpack_public_path__ + "media/images/countrysquared/sx-e3729d234fc0a4740a79876488a0b14d.svg";